import moment from 'moment';
import { Button } from 'primereact/button';
import { useMemo } from 'react';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';

function EventItem({ event, handleClickEvent, handleDuplicateEvent }) {
  return (
    <div className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100  h-44 ">
      <div
        className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full h-44"
        onClick={handleClickEvent}>
        <img
          className="h-32 w-32 object-cover shadow-md block rounded-md"
          src={event.image ? event.image.file : getImage('img-ph.png')}
          alt={event.image ? event.image.label : 'Non renseignée'}
        />
        <div className="flex flex-col justify-around h-full w-full">
          <div className="flex flex-col gap-y-1">
            <div className="text-xl font-bold text-slate-700 ">{event.title}</div>
            <div className="flex flex-row gap-1">
              <span className="font-medium text-slate-700">
                {moment(event.start_dt).format('LL')}
              </span>
              {'-'}
              <span className="font-medium text-slate-700">
                {moment(event.end_dt).format('LL')}
              </span>
            </div>
          </div>
          <div className="flex flex-row gap-x-3">
            <Tag
              tag={{
                label: getConstant('shared.draftTypes', event.is_draft).label,
                bgColor: getConstant('shared.draftTypes', event.is_draft).bgColor
              }}
            />
            <Tag
              tag={{
                label: getConstant('quatrebis.type', event.type).label,
                icon: 'star',
                bgColor: 'bg-sky-950'
              }}
            />
            <Tag
              tag={{
                label: getConstant('quatrebis.place', event.place).label,
                icon: 'location',
                bgColor: 'bg-green-800'
              }}
            />
            <Tag
              tag={{
                label: event.thematique?.label,
                icon: 'person',
                bgColor: 'bg-orange-800'
              }}
            />
          </div>
        </div>
      </div>
      <Button
        rounded
        icon="pi pi-clone"
        className="h-12 w-12"
        tooltip="Dupliquer l'évènement"
        tooltipOptions={{ position: 'left' }}
        onClick={handleDuplicateEvent}
        severity="secondary"
        outlined
      />
    </div>
  );
}

export default EventItem;
